<template>
  <div class="initials" v-bind:style="avatarStyle">
    <span v-if="!avatar">{{ initials }}</span>
  </div>
</template>

<script>

export default {

  props: ['avatar', 'name'],

  computed: {
    avatarStyle: function () {
      if (this.avatar) {
        return {
          backgroundImage: 'url("' + this.avatar + '")',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        }
      }
      return {}
    },

    initials: function () {
      var name = this.name
      if (!name) return ' '
      name = name.trim()
      var names = name.split(' ')
      var firstName = names[0]
      if (names.length === 1) { 
        var firstInitial = firstName[0] && firstName[0].toUpperCase()
        if (!firstInitial) return " "
        return firstInitial
      }
      var lastName = names[names.length - 1]
      var firstInitial = firstName && firstName[0] && firstName[0].toUpperCase()
      var lastInitial = lastName && lastName[0] && lastName[0].toUpperCase()
      var initials = " "
      if (firstInitial) initials = firstInitial
      if (lastInitial)  initials = initials + " " + lastInitial
      return initials
    }
  },
};
</script>

<style>

  .initials {
    width: 2.5em;
    background: #1e2022;
    color: #ffffff;
    height: 2.5em;
    justify-content: center;
    align-items: center;
    display: flex;
    border-radius: 50%;
    margin-right: 1em;
  }

</style>

